module.exports = __webpack_public_path__ + "assets/images/project/constituencies/bukit-panjang-smc.jpg?v=40d9b09a";